import { render, staticRenderFns } from "./physiologicalAxisMarketing.vue?vue&type=template&id=10b246fc&scoped=true&"
import script from "./physiologicalAxisMarketing.vue?vue&type=script&lang=js&"
export * from "./physiologicalAxisMarketing.vue?vue&type=script&lang=js&"
import style0 from "./physiologicalAxisMarketing.vue?vue&type=style&index=0&id=10b246fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b246fc",
  null
  
)

component.options.__file = "physiologicalAxisMarketing.vue"
export default component.exports